<template>
  <div style="min-height:600px;background-color: white">
    <a-breadcrumb style="padding: 16px 24px">
      <a-breadcrumb-item>
        <router-link :to="{name:'scf'}">
          <a-icon type="home" />
          <span>首页</span>
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item href="">
        <router-link :to="{name:'activity'}">
          <span>活动</span>
        </router-link>
      </a-breadcrumb-item>
    </a-breadcrumb>

    <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
      :title="item.name"
    >
      <template slot="extra">
      <a-button key="apply" type="primary" @click="toRegistration">
        立即报名
      </a-button>
    </template>
      <a-descriptions size="small" :column="3" v-if="item">
        <a-descriptions-item label="">
          <a-icon type="team"></a-icon>
          {{ item.pageview }}
        </a-descriptions-item>
        <a-descriptions-item label="">
          <a-icon type="clock-circle"></a-icon>
          {{ item.addTime.split('T')[0] }}
        </a-descriptions-item>

      </a-descriptions>

    </a-page-header>

    <!--    <div  id="course-info" v-html="item.desc"></div>-->
    <div style="padding: 16px 24px">
      <div v-html="item.desc" v-if="item">
      </div>

      <a-divider/>


      <router-link v-if="item.before" :to="{name:'activityInfo', params:{id:item.before.id}}">
        <<< 上一篇 {{item.before.name}}
      </router-link>
      <span v-else><<< 上一篇 无</span>
      <router-link class="float-right" v-if="item.next" :to="{name:'activityInfo', params:{id:item.next.id}}">
        {{item.next.name}}  下一篇 >>>
      </router-link>
      <span class="float-right" v-else>无 下一篇 >>></span>
    </div>


  </div>
</template>

<script>
import {domain, getActivityInfo,} from "../../api/api";
import {filterUnderLine} from "../../../static/js/util";

export default {
  name: "ActivityInfo",
  props: {id: ''},
  data() {
    return {
      item: ''
    };
  },
  watch: {
    $route(to, from) {
      if ((to.name === from.name) && (to.path !== from.path)) {
        if (to.params.id !== from.params.id) {
          this.id = to.params.id
          this.toGetInfo(this.id)
        }
      }

    }
  },
  mounted() {
    this.toGetInfo(this.id)
  },
  methods: {
    toRegistration(){
      this.$router.push({name:'apply', params:{'id':this.id}})
    },
    toGetInfo(id) {
      getActivityInfo(id)
        .then(res => {
          this.item = filterUnderLine(res.data)
          let w = window.screen.width;
          if (w < 400) {
            this.item.desc = this.item.desc.replace(/<img src="\/scf_media/g, '<img width="100%" src="' + `${domain}` + '/scf_media')
          } else {
            this.item.desc = this.item.desc.replace(/<img src="\/scf_media/g, `<img src="${domain}/scf_media`)
          }
        })
    }
  }
}
</script>

<style scoped>
a{
  color:var(--primaryColor)
}
a:hover{
  color:blue
}

</style>








// WEBPACK FOOTER //
// src/components/content/ActivityInfo.vue